import { gql } from '@apollo/client';

export const SendForgotPasswordMutation = gql`
    mutation SendForgotPassword($login: String!) {
        sendForgotPassword(login: $login) {
            email
        }
    }
`;
